import { ISvgProps, Svg } from '@components';
import { memo } from 'react';

export const PeopleIcon = memo<ISvgProps>((props, { className }) => (
  <Svg className={className} width="32" height="32" viewBox="0 0 32 32" {...props}>
    <rect id="Rectangle_4415" data-name="Rectangle 4415" width="32" height="32" fill="none" />
    <path
      id="Icon_awesome-users"
      data-name="Icon awesome-users"
      d="M4.8,11.163a3.2,3.2,0,1,0-3.2-3.2A3.2,3.2,0,0,0,4.8,11.163Zm22.4,0a3.2,3.2,0,1,0-3.2-3.2A3.2,3.2,0,0,0,27.2,11.163Zm1.6,1.6H25.6a3.191,3.191,0,0,0-2.255.93,7.314,7.314,0,0,1,3.755,5.47h3.3a1.6,1.6,0,0,0,1.6-1.6v-1.6A3.2,3.2,0,0,0,28.8,12.763Zm-12.8,0a5.6,5.6,0,1,0-5.6-5.6A5.6,5.6,0,0,0,16,12.763Zm3.84,1.6h-.415a7.732,7.732,0,0,1-6.85,0H12.16a5.761,5.761,0,0,0-5.76,5.76v1.44a2.4,2.4,0,0,0,2.4,2.4H23.2a2.4,2.4,0,0,0,2.4-2.4v-1.44A5.761,5.761,0,0,0,19.84,14.363Zm-11.185-.67a3.191,3.191,0,0,0-2.255-.93H3.2a3.2,3.2,0,0,0-3.2,3.2v1.6a1.6,1.6,0,0,0,1.6,1.6H4.895A7.332,7.332,0,0,1,8.655,13.693Z"
      transform="translate(0 3.238)"
      fill="#3477eb"
    />
  </Svg>
));

PeopleIcon.displayName = 'PeopleIcon';

export default PeopleIcon;
